// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 9966 ? "dashboard" : chunkId) + "." + {"9299":"82213374","9966":"d040fb90"}[chunkId] + ".css";
};